<template>
    <div class="card bg-white-base">
        <!-- @slot Slot onde conteúdo do card é inserido -->
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'BCard'
    }
</script>

<style lang="scss" scoped>
    .card {
        border-radius: 5px;
        box-shadow: 0px 4px 5px 0 rgba(0,0,0,0.14);
    }
</style>

<docs>
    Card

    A importação do arquivo abaixo é necessária para o funcionamento do componente:
    - colors-classes.scss

    Para a classe de padding do exemplo ser aplicada é necessário importar o arquivo: 
    - spacing.scss

    ```js
    <BCard class="padding-normal"><p>Card exemplo</p></BCard>
    ```
</docs>